/* Shared progressive enhancement. Native navigation and cart remain intact. */
(()=>{'use strict';
    // One document-wide light: quiet over content, larger/brighter over controls.
    if (!document.getElementById('mf-pointer-light')) {
      const light = document.createElement('span');
      light.id = 'mf-pointer-light';
      light.setAttribute('aria-hidden', 'true');
      document.body.append(light);
      const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let pointerFrame = 0, x = 0, y = 0;
      const hideLight = () => { light.classList.remove('is-visible'); };
      document.addEventListener('pointermove', event => {
        if (!finePointer.matches || event.pointerType === 'touch') { hideLight(); return; }
        x = event.clientX; y = event.clientY;
        const target = event.target instanceof Element ? event.target : null;
        const control = target?.closest('a[href],button,summary,input,textarea,select,label[for],[role="button"],[role="link"],video[controls]');
        const enabled = control && !control.matches(':disabled,[aria-disabled="true"],input[type="hidden"]');
        light.classList.toggle('is-action', Boolean(enabled));
        light.classList.toggle('is-reduced', reducedMotion.matches);
        // A modal occupies the top layer; put the decorative light in that layer too.
        const host = target?.closest('dialog[open]') || document.body;
        if (light.parentElement !== host) host.append(light);
        if (!pointerFrame) pointerFrame = requestAnimationFrame(() => {
          light.style.left = `${x}px`;
          light.style.top = `${y}px`;
          light.classList.add('is-visible');
          pointerFrame = 0;
        });
      }, { passive: true });
      document.addEventListener('pointerout', event => { if (!event.relatedTarget || event.relatedTarget instanceof HTMLIFrameElement) hideLight(); });
      document.addEventListener('mf:preview-close', () => {
        hideLight(); document.body.append(light);
      });
      document.addEventListener('keydown', hideLight);
      document.addEventListener('visibilitychange', () => { if (document.hidden) hideLight(); });
      window.addEventListener('blur', hideLight);
      window.addEventListener('pagehide', hideLight);
      finePointer.addEventListener('change', hideLight);
    }

})();
/* Mark a real page destination, not every home-page hash, as current. */
(() => {
 const header = document.getElementById('shopify__header__section');
 if (!header) return;
 const clean = path => path.replace(/\/$/, '') || '/';
 header.querySelectorAll('.mf-home-nav a[href]').forEach(link => {
   const target = new URL(link.href, location.href);
   if (!target.hash && target.origin === location.origin && clean(target.pathname) === clean(location.pathname)) {
     link.setAttribute('aria-current', 'page');
     link.closest('details')?.classList.add('mf-nav-current');
   }
 });
 const dropdowns = [...header.querySelectorAll('.mf-home-nav>li>details')];
 dropdowns.forEach(menu => menu.addEventListener('toggle', () => {
   if (menu.open) dropdowns.forEach(other => { if (other !== menu) other.open = false; });
 }));
 document.addEventListener('click', event => {
   if (header.contains(event.target)) return;
   header.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
 });
})();

document.addEventListener('toggle', event => {
  const detail = event.target;
  if (detail instanceof HTMLDetailsElement && detail.matches('.mf-product-guidance__video') && !detail.open) {
    detail.querySelectorAll('video').forEach(video => video.pause());
  }
}, true);
